import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<p>Redirecting...</p>`,
})
export class TeamsRouterComponent implements OnInit {
  private readonly route = inject(ActivatedRoute)

  ngOnInit() {
    const tid = this.route.snapshot.queryParams['tid'] ?? null
    console.log('Teams router: tid =', tid)

    // TODO: for segregated environments, look up tenant → domain mapping using tid
    // and redirect to https://{clientDomain}/teams/panel.
    // For now, redirect to panel on the current domain.
    window.location.pathname = '/teams/panel'
  }
}
